import { APP_HEADER_HEIGHT, APP_HEADER_HEIGHT_DESKTOP } from '~/constants/main'

export const useHeaderHeight = () => {
  const { thresholds, width } = useNuxtApp().$vuetify.display

  const breakpoint = thresholds.value.md

  return {
    height: computed(() => {
      return width.value >= breakpoint ? APP_HEADER_HEIGHT_DESKTOP : APP_HEADER_HEIGHT
    }),
  }
}
